import sanitizeHtml from 'sanitize-html';

export default {

  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue, options) {
    // ES6 way of const job = options.job
    // Add $plugin instance method directly to Vue components
    Vue.prototype.$sanitize = this.sanitize;
  },
  sanitize (dirtystring) {
    return sanitizeHtml(dirtystring,
      {
        allowedTags: ['input', 'span', 'img','b','strong'],
        allowedAttributes: {
          'img': [ 'src' ],
          'input': ['type', 'checked', 'disabled'],
          'span': ['style', 'class']
        
        }
      });
  }
};
